export const padToTwoDigits = (num) => {
  return num.toString().padStart(2, '0');
}

export const formatDate = (date) => {
  return [
    date.getFullYear(),
    padToTwoDigits(date.getMonth() + 1),
    padToTwoDigits(date.getDate()),
  ].join('-');
}

export const formatDateRange = (dateString) => {
  const date = new Date(dateString);
  return [
    padToTwoDigits(date.getMonth() + 1), // MM
    padToTwoDigits(date.getDate()),      // DD
    date.getFullYear()                   // YYYY
  ].join('/');
}

export const formatDateTime = (date) => {
  // if (date && date.__time__) return date.__time__.split('T')[0];
  // todo fix date
  if (date) return date.split('T')[0];
  return null;
}

export const formatDateTimeToYear = (date) => {
  // if (date && date.__time__) return date.__time__.split('T')[0];
  // todo fix date
  if (!date) return null;
  const newDate = new Date(date);
  return newDate.getFullYear();
}
